<template>
  <nav
    class="navbar navbar-expand-md navbar-light"
    :class="{
      'nav-open': navOpen
    }"
  >
    <div class="container">
      <router-link class="navbar-brand logo" to="/" @click.native="closeMenu">
        <img src="@/assets/img/logo.svg" alt="CTO Circle" height="30px" />
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        @click.prevent="openMenu"
        aria-controls="mainNav"
        aria-expanded="false"
      >
        <i class="icons8-menu-rounded"></i>
      </button>
      <hr />
      <div class="collapse navbar-collapse" id="mainNav" ref="navbar">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link
              class="nav-link"
              @click.native="closeMenu"
              to="/initiatives"
              >Initiatives</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click.native="closeMenu" to="/cities"
              >Cities</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click.native="closeMenu" to="/events"
              >Events</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click.native="closeMenu" to="/jobs"
              >Jobs</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              @click.native="closeMenu"
              to="/podcasts"
              >Podcast</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click.native="closeMenu" to="/about"
              >About</router-link
            >
          </li>
          <div class="login ml-md-4">
            <cs-button
              href="https://csuitecircle.typeform.com/to/fEytYh02"
              variant="primary"
              fill="solid"
              size="medium"
              target="_blank"
              >Request an Invite</cs-button
            >
          </div>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import $auth from '@/services/auth.js';

export default {
  name: 'app-nav',
  data() {
    return {
      networks: ['CEO', 'CFO', 'CMO', 'COO', 'CIO', 'CTO'],
      sisterSites: [
        'C-Suite Consulting',
        'C-Suite Philanthropy',
        'C-Suite Jobs',
        'C-Suite Deals',
        'C-Suite Wealth',
        'C-Suite Awards'
      ],
      loggedIn: false,
      user: {},
      navOpen: false
    };
  },
  methods: {
    closeMenu() {
      this.navOpen = false;
      $(this.$refs.navbar).collapse('hide');
    },

    openMenu() {
      this.navOpen = !this.navOpen;
      if (this.navOpen) {
        $(this.$refs.navbar).collapse('show');
      } else {
        $(this.$refs.navbar).collapse('hide');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
nav.navbar {
  position: fixed;
  top: 0;
  // width: 100%;
  width: 100vw;
  padding: 18px 0;
  background: #fff;
  z-index: 99;
  box-shadow: 0 1px 12px 0px rgba(0, 0, 0, 0.6);
  @include media-breakpoint-down(sm) {
    padding: 18px 18px;
  }

  &.navbar-transparent {
    background-color: transparent;
    border-bottom: 1px solid transparent;
    position: absolute;
    width: 100%;
    color: #ffffff;

    &.nav-open {
      background-color: rgba(0, 0, 0, 0.9);
    }

    .navbar-brand {
      color: #ffffff;
      &.router-link-exact-active {
        color: inherit;
      }
    }

    button.navbar-toggler i {
      color: #ffffff;
    }

    .navbar-nav .nav-link {
      color: #ffffff;
    }

    hr {
      display: none;
    }
  }

  .navbar-brand {
    color: $secondary;

    span {
      font-weight: 900;
      font-size: 26px;
    }

    &.router-link-exact-active {
      color: $secondary;
    }

    &:hover {
      color: $primary;
    }
  }

  button.navbar-toggler {
    outline: none;
    padding: 0;
    border: none;

    i {
      font-size: 36px;
      color: $secondary;
    }

    &[aria-expanded='true'] {
      i {
        color: $primary;
      }
    }
  }

  .navbar-collapse {
    padding: 0 20px;

    @include media-breakpoint-up(md) {
      display: none;
      z-index: 0;
      &.show {
        display: flex;
        flex-direction: row;
      }
    }

    @include media-breakpoint-up(lg) {
      padding: 0;
    }
  }

  hr {
    position: absolute;
    left: 0;
    top: 83px;
    z-index: 1;
    // width: 100%;
    border-top: 1px solid #f2f2f2;
    @include media-breakpoint-up(md) {
      display: none;
    }
  }

  .navbar-nav {
    position: relative;
    text-align: center;
    margin-top: 60px;
    width: 100%;

    @include media-breakpoint-up(md) {
      margin-top: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
    }

    @include media-breakpoint-up(lg) {
      justify-content: flex-end;
      margin-left: 20px;
    }

    @include media-breakpoint-up(xl) {
      margin-left: 100px;
      flex-wrap: nowrap;
    }

    .nav-link {
      color: $secondary;
      font-size: 16px;
      font-weight: 600;
      @include media-breakpoint-up(md) {
        padding-right: 0.7rem;
        padding-left: 0.7rem;
      }
      @include media-breakpoint-up(xl) {
        padding-right: 1rem;
        padding-left: 1rem;
      }

      &:hover {
        color: $primary;
      }

      &:first-of-type {
        @include media-breakpoint-down(md) {
          padding-left: 0;
        }
      }
    }
    li {
      &:first-of-type {
        padding-left: 0;
      }
    }

    .router-link-exact-active {
      color: $primary;
    }
  }

  i {
    font-size: 22px;
    color: $grey-icon;
  }

  .login {
    text-align: center;
    margin-top: 20px;
    @include media-breakpoint-up(md) {
      margin-top: 0;
      width: 12rem;
    }

    .dropdown-menu {
      @include media-breakpoint-down(sm) {
        text-align: center;
        margin-top: 15px;
        max-width: 230px;
        margin: 15px auto;
        position: relative;
        float: initial;
      }
    }
    .dropdown-item {
      &:hover {
        background: $primary;
        color: #ffffff;
      }
    }
  }

  .search {
    .btn-outline-primary {
      padding: 3px 18px 0;
      border: 1px solid $border-color;
      border-left: none;
      background-color: $light-grey;
      outline: none;

      &:hover,
      &:active {
        border-left: none;
        box-shadow: none;
      }
    }

    .input-group {
      input {
        padding-left: 25px;
        border-right: none;
        height: 50px;
      }
    }

    &.mobile {
      display: block;
      @include media-breakpoint-up(md) {
        display: none;
      }
      i {
        color: $secondary;
      }
    }

    &.desktop {
      display: none;
      @include media-breakpoint-up(lg) {
        display: block;
      }
    }
  }

  #userDetail strong {
    width: 6em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;

    @include media-breakpoint-up(md) {
      width: 4em;
    }

    @include media-breakpoint-up(xl) {
      width: 6em;
    }
  }
}
nav.nav-open hr {
  width: 100%;
}
</style>
